// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_echarts_index_js":"ee2b4fd7787fb2c0","quill":"0b18f353d28ff852"}[chunkId] + ".js";
};